import { Button, AddStroke16 } from '@cian/ui-kit';
import * as React from 'react';

import { IAreaPartAddButtonProps } from './types';

export const AreaPartAddButton: React.FC<IAreaPartAddButtonProps> = props => {
  const { onClick } = props;

  return (
    <Button
      beforeIcon={<AddStroke16 color="primary_100" />}
      fullWidth
      theme="fill_secondary"
      onClick={onClick}
      type="button"
    >
      Добавить площадь
    </Button>
  );
};
